<template>
  <v-footer height="auto" class="pa-0">
    <v-toolbar>
      <div class="container d-flex align-center" style="height: 100%">
        <div class="d-xs-flex d-sm-none d-md-flex">
          &copy;2022,&nbsp;<strong>Colorado State Forest Service</strong>
        </div>
        <v-spacer />
        <v-btn
          class="d-none d-sm-flex"
          text
          href="https://csfs.colostate.edu/"
          target="_blank"
        >
          CSFS
        </v-btn>
        <v-btn class="d-none d-sm-flex" text @click="showDisclaimer">
          Disclaimer
        </v-btn>
        <v-btn
          class="d-none d-sm-flex"
          text
          href="https://www.colostate.edu/equal-opportunity/"
          target="_blank"
        >
          Equal Opportunity
        </v-btn>
        <v-btn
          class="d-none d-sm-flex"
          text
          href="https://www.colostate.edu/privacy/"
          target="_blank"
        >
          Privacy Statement
        </v-btn>
        <v-divider class="d-none d-sm-flex" vertical />
        <v-btn text class="accent--text ml-2 d-none d-sm-flex" nuxt to="/login">
          SIGN IN
        </v-btn>
      </div>
    </v-toolbar>
  </v-footer>
</template>

<script>
export default {
  methods: {
    showDisclaimer() {
      this.$emit("showdisc");
    },
  },
};
</script>
